<div class="icon-selector-wrap">
  <div class="icon-selector-component-header">
    <div>
      <!-- backupType 'icon' is for existing apps iconType -->
      <!-- Eventhough icon type will be changed from 'icon' to 'classIcon', the below if condition is for fallback -->
      <div *ngIf="(backupType === 'icon' || backupType === 'classIcon' || backupType === 'systemIcon') && value">
        <span
          ><img
            *ngIf="!isFontAwesomeIcon(value?.icon?.value)"
            [src]="getSvgPath(value?.icon?.value)"
            [ngStyle]="{ 'width': value?.iconSize || '13px', 'height': value?.iconSize || '13px' }"
            [alt]="value?.icon?.label"
            class="svg-icon-display"
          />
          <i
            *ngIf="isFontAwesomeIcon(value?.icon?.value)"
            class="fa"
            [ngClass]="value?.icon?.value"
            [ngStyle]="{ color: value?.iconColor, 'font-size': value?.iconSize }"
          ></i
        >
        </span>
      </div>
      <div *ngIf="backupType === 'uploaded'">
        <img [attr.id]="element.name + '_img_display'" class="prop-img-display" [alt]="element.name" />
      </div>
    </div>
    <div class="d-flex align-items-center" *ngIf="!disableField">
      <span
        class="clear cursor-pointer"
        *ngIf="value && !isMenuElement"
        (click)="triggerClearValueConfirmation(element)"
        (keyup.enter)="triggerClearValueConfirmation(element)"
        tabindex="0"
        aria-label="Clear value"
        ><i class="pi pi-times"></i
      ></span>
      <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-text" (onClick)="showPanel()" />
    </div>
  </div>

  <p-dialog
    [(visible)]="showIconSelectorPopUp"
    styleClass="icon-selector-modal"
    [style]="{ width: '90vw', height: '90vh', padding: '0px' }"
    [draggable]="false"
    [modal]="true"
    appendTo="body"
    [closable]="false"
  >
    <ng-template #header>
      <div class="d-flex flex-prototype" style="flex-direction: column">
        <span *ngIf="!isHomePageImageSelection">{{ 'SELECT_ICON' | translate }}</span>
        <span *ngIf="isHomePageImageSelection">{{ 'SELECT_IMAGE' | translate }}</span>
      </div>
    </ng-template>
    <div class="row m-2 mr-0 ml-0 row-format" [ngClass]="{ 'justify-content-center': isHomePageImageSelection }">
      <div class="col-10 col-format" *ngIf="!isHomePageImageSelection">
        <div class="d-flex pb-2">
          <label class="label" for="icon-search-input">Icon</label>
          <div class="formgroup-inline searchbox-button">
            <div class="field">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                <input
                  id="icon-search-input"
                  type="text"
                  class="p-inputtext p-component p-element"
                  placeholder="Search"
                  aria-describedby="basic-addon1"
                  [(ngModel)]="searchTerm"
                  [ngModelOptions]="{ standalone: true }"
                  (search)="filterIcon()"
                  (keyup)="filterIcon()"
                />
                <span
                  class="p-inputgroup-addon cursor-pointer"
                  *ngIf="searchTerm !== '' && searchTerm !== undefined && searchTerm !== null"
                  (click)="searchTerm = ''; filterIcon()"
                  (keyup.enter)="searchTerm = ''; filterIcon()"
                  tabindex="1"
                  aria-label="Search term"
                  ><i class="pi pi-times"></i
                ></span>
              </div>
            </div>
          </div>
        </div>

        <div class="icon-section-wrapper">
          <div class="icon-category-sidebar" #categorySidebar>
            <ul>
              <li
                *ngFor="let group of filteredIconGroups; trackBy: trackByCategory"
                [attr.data-sidebar-category]="group.category"
                [ngClass]="{ 'active': group.category === activeCategory }"
                (click)="scrollToCategory(group.category)"
                (keydown.enter)="scrollToCategory(group.category)"
                tabindex="0"
                role="button"
              >
                {{ group.category }}
              </li>
            </ul>
          </div>
          <div class="icon-wrapper" #iconScrollContainer (scroll)="onIconScroll()">
            <div *ngFor="let group of filteredIconGroups; trackBy: trackByCategory" class="icon-group" [attr.data-category]="group.category">
              <div class="icon-group-header">{{ group.category }}</div>
              <div class="icon-group-icons">
                <button
                  type="button"
                  class="svg-icon-btn"
                  [ngClass]="{ 'active-icon': icon?.value === selectedIcon?.value }"
                  (click)="selectIcon(icon)"
                  *ngFor="let icon of group.icons; trackBy: trackByIcon"
                  showDelay="100"
                  hideDelay="100"
                  tooltipPosition="top"
                  tooltipStyleClass="label-tooltip custom-tooltip-properties"
                  pTooltip="{{ icon.label }}"
                >
                  <img [src]="getSvgPath(icon.value)" [alt]="icon.label" class="svg-icon-grid" loading="lazy" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="preview-col" [ngClass]="{ 'col-2': !isHomePageImageSelection, 'col-10': isHomePageImageSelection }">
        <label class="label" for="preview-section">Preview</label>
        <span>
          <div
            id="preview-section"
            class="preview-section-wrapper"
            *ngIf="
              (iconType !== 'uploaded' && selectedIcon && selectedIcon?.value) ||
              (iconType === 'uploaded' && element && element.name)
            "
            [ngClass]="{ 'w-100': isHomePageImageSelection }"
          >
            <p-button *ngIf="!isMenuElement" icon="fa fa-trash" styleClass="icon-remove" (onClick)="removeSelectedImg()" />
            <ng-container *ngIf="iconType !== 'uploaded'">
              <img
                *ngIf="!isFontAwesomeIcon(selectedIcon?.value)"
                [src]="getSvgPath(selectedIcon?.value)"
                [alt]="selectedIcon?.label"
                class="svg-icon-preview"
              />
              <i
                class="{{ selectedIcon && selectedIcon.value }}"
                *ngIf="isFontAwesomeIcon(selectedIcon?.value)"
                [ngStyle]="{ 'font-size': iconSize || '12px' }"
              ></i>
            </ng-container>
            
            <img
              [attr.id]="element.name + '_img'"
              class="prop-img-uploader"
              *ngIf="iconType === 'uploaded'"
              [alt]="element.name"
            />
          </div>
        </span>
        <div *ngIf="iconType !== 'uploaded' && selectedIcon && selectedIcon.value">
          <span class="sub-text pl-1">{{ selectedIcon.label }}</span>
        </div>
        <div class="icon-loader-container" *ngIf="imageLoading && showIconSelectorPopUp">
          <p-progress-spinner></p-progress-spinner>
        </div>
      </div>
    </div>

    <ng-template #footer>
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <div class="d-flex align-items-center">
          <button type="button" class="btn btn-primary cancel-btn upload-btn" (click)="iconSelector.click()">
            <span *ngIf="!isHomePageImageSelection">{{ 'UPLOAD_ICON' | translate }}</span>
            <span *ngIf="isHomePageImageSelection">{{ 'UPLOAD_IMAGE' | translate }}</span>
          </button>

          <input
            type="file"
            (change)="onIconUpload($event, element.name, element)"
            class="invisible"
            accept=".jpg,.jpeg,.png,.gif,.svg"
            #iconSelector
          />
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <button type="button" class="btn btn-primary cancel-btn" (click)="confirmClosePopup()">
            {{ 'CANCEL' | translate }}
          </button>
          <button type="button" class="save-btn btn btn-primary" (click)="saveSelectedIcon()">
            {{ 'SAVE' | translate }}
          </button>
        </div>
      </div>
    </ng-template>
  </p-dialog>
</div>

